import React, { useEffect, useState } from 'react';
import { Home } from './pages/Home';
import { Privacy } from './pages/Privacy';
import { ContactModalProvider } from './components/ContactModalContext';
import { CookieBanner } from './components/CookieBanner';
import { SEO } from './components/SEO';
function App() {
  const [route, setRoute] = useState<string>(typeof window !== 'undefined' ? window.location.hash : '');
  useEffect(() => {
    const onHashChange = () => setRoute(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  const isPrivacy = route.startsWith('#/privacy');
  return <ContactModalProvider data-id="element-0">
      {isPrivacy ? <>
          <SEO title="Политика конфиденциальности — 2opinion" description="Политика в отношении обработки персональных данных оператора. Условия использования cookie-файлов и сервиса 2opinion." path="/privacy" data-id="element-1" />
          <Privacy data-id="element-2" />
        </> : <>
          <SEO title="Второе мнение по операции на позвоночнике — 2opinion" description="Независимая экспертная оценка медицинской документации от ТОП-20 врачей Москвы по позвоночнику. Два мнения за 48 часов — без поездок, давления и конвейера." keywords="второе мнение, позвоночник, грыжа диска, операция позвоночник, нужна ли операция, экспертная оценка МРТ, нейрохирург Москва, второе мнение врача" path="/" data-id="element-3" />
          <Home data-id="element-4" />
        </>}
      <CookieBanner data-id="element-5" />
    </ContactModalProvider>;
}
export { App };